var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9808 2.04166L10.4215 4.1227L7.04297 3.34231C5.22377 2.88708 3.01473 2.56192 2.10512 2.56192C-0.298833 2.56192 0.090997 5.09819 2.81981 7.76452L5.09382 9.97563L2.42998 12.707C0.740714 14.3978 -0.16889 15.8936 0.0260252 16.6089C0.220941 17.7145 0.805686 17.8446 5.80851 17.6495L11.2661 17.4544L12.5006 19.5354C17.1136 27.4043 21.2068 27.4694 19.1277 19.6004L18.2181 16.2187L19.9074 15.8286C24.9102 14.723 25.5599 14.4629 25.5599 13.5524C25.5599 13.0322 23.6757 11.6665 21.4017 10.5609C16.5938 8.15472 16.139 7.63446 16.139 4.38283C16.139 -0.494608 14.6447 -1.34003 11.9808 2.04166ZM7.69269 7.1142C7.69269 7.43936 7.56275 7.76452 7.4328 7.76452C7.23789 7.76452 6.91303 7.43936 6.71812 7.1142C6.5232 6.724 6.65314 6.46387 6.978 6.46387C7.36783 6.46387 7.69269 6.724 7.69269 7.1142ZM12.7605 9.19524C13.2153 9.65047 13.5401 11.0161 13.5401 12.2518V14.5929L11.4611 12.5119C9.70682 10.756 9.57687 10.3008 10.2916 9.45537C11.2661 8.21975 11.7209 8.15472 12.7605 9.19524ZM8.21247 14.1377C8.34241 14.5929 7.75766 14.9181 6.71812 14.9181C5.15879 14.9181 5.02885 14.788 5.74354 13.9426C6.65314 12.8371 7.75766 12.9021 8.21247 14.1377Z",
    fill: "#FD853A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar1);
export default __webpack_public_path__ + "static/media/star_1.c1cc1178c84432e92fd0f841874d3701.svg";
export { ForwardRef as ReactComponent };